/**
 * Categorical colors for tools. Hues are assigned in FIXED order by tool identity (never by rank
 * or position), so a tool keeps its color on every chart, tile and legend. Tints of the brand
 * hues, validated for lightness / chroma / CVD separation / contrast on a light surface.
 */
export const TOOL_ORDER = ['Claude Code', 'Codex', 'Claude'] as const;

const TOOL_COLORS: Record<string, string> = {
  'Claude Code': '#3560c0',
  Codex: '#dd6e0c',
  Claude: '#7c3aed'
};

export const OTHER_TOOL_COLOR = '#0d9488';

export function toolColor(tool: string): string {
  return TOOL_COLORS[tool] ?? OTHER_TOOL_COLOR;
}

/** Known tools first in fixed order, then any others alphabetically. */
export function sortTools(tools: Iterable<string>): string[] {
  const set = new Set(tools);
  const known = TOOL_ORDER.filter(t => set.has(t));
  const rest = [...set].filter(t => !(TOOL_ORDER as readonly string[]).includes(t)).sort();
  return [...known, ...rest];
}
